<!--src/App.vue-->
<template>
  <div id="app">
    <!-- 1. 非登录/注册页：显示导航、布局外壳、底部 -->
    <div v-if="!isAuthPage">
      <NavBox />
      <LayoutCommon />
      <CommonFooter />
    </div>
    <!-- 2. 登录/注册页：只显示组件内容（无导航/布局/底部） -->
    <div v-else>
      <!-- 关键：登录/注册组件必须通过 router-view 渲染 -->
      <router-view />
    </div>
  </div>
</template>

<script setup>
import NavBox from '@/components/nav/NavBox.vue'
import LayoutCommon from './views/LayoutCommon.vue'
import CommonFooter from '@/components/footer/CommonFooter.vue'
import { useRoute } from 'vue-router'
import { computed, onMounted } from 'vue'
import { refreshToken } from '@/api/user';
import { useUserStore } from '@/store/modules/userStore';
import pinia from '@/store/index.js';

const route = useRoute()
const isAuthPage = computed(() => {
  const path = route.path.toLowerCase()
  const authPaths = [
    '/login',
    '/register',
    '/favorite',
    '/myorder',
    '/mybill',
    '/getcoupons',
    '/personalcenter',
    '/accountsetting',
    '/searchresult',
    '/strategy'
  ]
  return authPaths.some(prefix => path.startsWith(prefix))
})

// 修复：onMounted放在script setup内部，确保执行
onMounted(async () => {
  const refreshTokenStr = localStorage.getItem('refreshToken');
  const accessTokenSession = sessionStorage.getItem('accessToken');
  const accessTokenLocal = localStorage.getItem('accessToken');

  // 检测分享链接参数
  const urlParams = new URLSearchParams(window.location.search);
  const productId = urlParams.get('productId');
  const platform = urlParams.get('platform');
  const goodsSign = urlParams.get('goodsSign');
  const clickUrl = urlParams.get('clickUrl');
  if (productId && platform) {
    console.log('[App] 检测到分享链接参数:', { productId, platform, goodsSign, clickUrl: clickUrl ? 'present' : 'missing' })
    // 存储到 sessionStorage，页面加载后由 carousel 组件处理
    sessionStorage.setItem('shareProductId', productId)
    sessionStorage.setItem('sharePlatform', platform)
    // 拼多多商品详情需要goodsSign
    if (goodsSign) {
      sessionStorage.setItem('shareGoodsSign', goodsSign)
    }
    // 拼多多购买链接需要clickUrl
    if (clickUrl) {
      sessionStorage.setItem('shareClickUrl', decodeURIComponent(clickUrl))
    }
  }

  // 若本地已有 accessToken，直接同步到 sessionStorage，避免多余刷新
  if (accessTokenSession || accessTokenLocal) {
    if (!accessTokenSession && accessTokenLocal) {
      sessionStorage.setItem('accessToken', accessTokenLocal);
    }
    // 同步更新 Pinia store 状态，确保其他组件能读到最新登录状态
    const userStore = useUserStore(pinia);
    await userStore.initUserStatus();
    return;
  }

  if (refreshTokenStr) {
    try {
      const res = await refreshToken({ refreshToken: refreshTokenStr });
      sessionStorage.setItem('accessToken', res.data.accessToken);
      localStorage.setItem('accessToken', res.data.accessToken);
      
      // 刷新成功后，更新 Pinia store 状态，确保其他组件能读到最新登录状态
      const userStore = useUserStore(pinia);
      await userStore.initUserStatus();
      
      // 主动触发storage事件，通知个人中心等组件更新状态
      window.dispatchEvent(new StorageEvent('storage', { key: 'accessToken' }));
    } catch (error) {
      // 刷新失败不立即清空 token，避免误登出（后续请求拦截器会再次尝试刷新）
      console.warn('刷新 accessToken 失败，将保留现有 token：', error && error.message);
    }
  }
});
</script>

<style lang="scss">

</style>
<style>

</style>
